import FieldsGridRowWrapper from '../FieldsGridRowWrapper';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const FieldsGridHeader: FunctionComponent<Props> = ({ children, ref, testId = TEST_ID }) => (
    <FieldsGridRowWrapper ref={ref} testId={testId}>
        {children}
    </FieldsGridRowWrapper>
);

export default FieldsGridHeader;
